export const rootPaths = {
  root: '/',
  userRoot: 'user',
  errorsRoot: 'errors',
  formsRoot: 'forms',
  layoutRoot: 'layouts',
  ordersRoot: 'orders',
  customersRoot: 'customers',
  clientsRoot: 'clients',
  subscriptionsRoot: 'subscriptions',
  settingsRoot: 'token-settings'
};

const paths = {
  slaDashboard: '/sla-dashboard',
  orderIntakeForm: `/${rootPaths.ordersRoot}/order-intake-form`,
  orderOverview: `/${rootPaths.ordersRoot}/order-overview`,
  clientDetails: (clientId: string) => `/${rootPaths.clientsRoot}/${clientId}`,
  clientActivities: (clientId: string) =>
    `/${rootPaths.clientsRoot}/${clientId}/activities`,
  userProfile: `/${rootPaths.userRoot}/profile`,
  userSettings: `/${rootPaths.userRoot}/settings`,
  verticalNavLayout: `/${rootPaths.layoutRoot}/vertical-nav-layout`,
  topNavLayout: `/${rootPaths.layoutRoot}/top-nav-layout`,
  doubleTopNavLayout: `/${rootPaths.layoutRoot}/double-top-nav-layout`,
  comboNavLayout: `/${rootPaths.layoutRoot}/combo-nav-layout`,
  error404: '/errors/404',
  error500: '/errors/500'
} as const;

export default paths;
